import { Plus } from 'lucide-react';
import './Navbar.css';

export default function Navbar({ view, onNavigate, onViewChange }) {
  const getPageTitle = (view) => {
    switch (view) {
      case 'dashboard':
      case 'tests':
      case 'test-detail':
      case 'reports': return null; // No title in navbar for these views
      case 'settings': return null;
      case 'admin': return 'Admin Panel';
      case 'create-test': return null;
      default: return 'BharatQA';
    }
  };

  const title = getPageTitle(view);

  return (
    <nav className={`navbar${['home', 'login'].includes(view) ? ' navbar-hidden' : ''}`}>
      <div className="navbar-container">
        <div className="navbar-left">
          {title && (
            <span style={{ fontSize: '15px', fontWeight: '500', color: 'white' }}>
              {title}
            </span>
          )}
        </div>

        <div className="navbar-right">
          {/* Dashboard-specific actions removed as they are now in the page header */}
        </div>
      </div>
    </nav>
  );
}